import { OutsideWriteLock } from '@kanos/ui';
import { AreaPage, NotFoundState, ProfileArea, profilePageOf } from '@kanos/web-core';
import { createFileRoute, Link, useNavigate } from '@tanstack/react-router';
import { CalendarFeedCard } from '../firm/calendar-feed-card';
import { NotificationSettingsCard } from '../firm/notification-settings-card';
import { useMe } from '../me';

export const Route = createFileRoute('/profile/$')({
  component: ProfilePage,
});

/** A tab of „Anmeldung & Sicherheit“ below `/profile`. */
const securitySplat = (tab: string) => (tab ? `security/${tab}` : 'security');

/** A page of the own profile: an area, or a tab of „Anmeldung & Sicherheit“. */
function ProfilePage() {
  const { _splat: rest = '' } = Route.useParams();
  const me = useMe();
  const navigate = useNavigate();
  // The firm app's own areas (ADR-042); the others are every app's.
  if (rest === 'notifications') {
    return (
      <AreaPage title="Benachrichtigungen">
        <NotificationSettingsCard />
      </AreaPage>
    );
  }
  if (rest === 'calendar') {
    return (
      <AreaPage title="Kalender">
        <CalendarFeedCard />
      </AreaPage>
    );
  }
  const page = profilePageOf(rest);
  if (!page) return <NotFoundState onHome={() => void navigate({ to: '/' })} />;
  // The person's own account and devices are theirs, not the firm's: open after its contract's
  // end too (ADR-045) - as the API keeps them (`access: 'session'`).
  return (
    <OutsideWriteLock>
      <ProfileArea
        me={me}
        area={page.area}
        tab={page.tab}
        go={(tab) =>
          void navigate({
            to: '/profile/$',
            params: { _splat: securitySplat(tab) },
          })
        }
        link={(tab, content, className, current) => (
          <Link
            to="/profile/$"
            params={{ _splat: securitySplat(tab) }}
            aria-current={current ? 'page' : undefined}
            className={className}
          >
            {content}
          </Link>
        )}
      />
    </OutsideWriteLock>
  );
}
